import {makeAutoObservable} from "mobx"
import {IWarehouseCondition} from "../../api/StockSettingsApi"


export default class WarehouseCondition implements IWarehouseCondition {
    private _save: () => void

    get then_value(): number {
        return this._then_value
    }

    set then_value(value: number) {
        if (value >= 0 || isNaN(value)) {
            this._then_value = value
            this._save()
        }
    }

    get if_value(): number {
        return this._if_value
    }

    set if_value(value: number) {
        if (value >= 0) {
            this._if_value = value
            this._save()
        }
    }

    get type(): string {
        return this._type
    }

    set type(value: string) {
        this._type = value
        this._save()
    }

    static get conditions(): { label: string; value: string }[] {
        return this._conditions
    }

    private static _conditions = [{label: "меньше", value: "<"}, {label: "больше", value: ">"}, {
        label: "равно",
        value: "="
    }]
    private _type: string = ">"
    private _if_value: number = 0
    private _then_value: number = 0

    constructor(save: () => void, condition?: IWarehouseCondition) {
        if (condition) {
            this._type = condition.type
            this._if_value = condition.if_value
            this._then_value = condition.then_value
        }

        this._save = save
        makeAutoObservable(this)
    }
}